<template>
    <v-container fluid>
        <v-row no-gutters @click="clicked">
            <v-col cols="4">
                {{ label }}
            </v-col>
            <v-col cols="8">
                <div class="text-no-wrap">
                    <div class="align-self-center">
                        <div class="d-flex justify-left">
                            <div class="align-self-center">
                                {{ value }}
                            </div>
                            <div v-if="warning">
                                <v-tooltip top color="primary" max-width="400">
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" class="ml-3 align-self-center" color="amber darken-1">
                                            mdi-alert
                                        </v-icon>
                                    </template>
                                    {{ warning }}
                                </v-tooltip>
                            </div>
                            <div class="align-self-center">
                                <slot></slot>
                            </div>
                        </div>
                    </div>

                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import {clipboardMixin} from "@/components/mixins/clipboardMixin.js";

export default {

    mixins: [clipboardMixin],

    components: {},

    props: {

        label: {
            required: true,
            type: String,
        },

        value: {
            required: true,
            type: String | Number,
        },

        warning: {
            required: false,
            type: String | null,
            default: null
        }
    },

    methods: {
        clicked() {
            this.copyToClipboard(this.value);
            Bus.$emit('flash-message', {message: 'Copied to the clipboard'});
        }
    }
}
</script>
